var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88396 2C5.08485 2 2.00016 5.08469 2.00016 8.8838C2.00016 12.6829 5.08485 15.7676 8.88396 15.7676C12.6831 15.7676 15.7678 12.6829 15.7678 8.8838C15.7678 5.08469 12.6831 2 8.88396 2ZM8.88396 3.11629C12.0669 3.11629 14.6515 5.70088 14.6515 8.8838C14.6515 12.0667 12.0669 14.6513 8.88396 14.6513C5.70104 14.6513 3.11645 12.0667 3.11645 8.8838C3.11645 5.70088 5.70104 3.11629 8.88396 3.11629Z",
    fill: "#5D616C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8364 17.0478L13.7508 12.9614C13.5327 12.7433 13.1793 12.7433 12.9612 12.9614C12.7432 13.1794 12.7432 13.5329 12.9612 13.751L17.0476 17.8366C17.2649 18.0547 17.6191 18.0547 17.8364 17.8366C18.0545 17.6193 18.0545 17.2651 17.8364 17.0478Z",
    fill: "#5D616C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.e2798931e4a21d0fe1549bbbb455d27e.svg";
export { ForwardRef as ReactComponent };